module.exports = __webpack_public_path__ + "img/3.67e721b9.png";